export default __webpack_public_path__ + "static/media/tick_mark.e90d8f9b.svg";